import _ from 'lodash'
import { Col, Card, Button, Form } from 'react-bootstrap'
import { Crop, ArrowRightLeft } from 'lucide-react'
import AppModal from '@/components/common/AppModal'
import ImageCropper from './Cropper'
import { useState } from 'react'
import { Media } from '@/components/mediaBuying/adCreatives/screens/mediaCrop/Media'

const MediaFormat = ({
    title,
    aspect,
    ratio,
    aspectRatio,
    originalUrl,
    selectedOption,
    croppedAreaPixels,
    onOptionChange,
    croppedArea,
    videoDuration,
    onCrop,
    type,
    canvasWidth,
    canvasHeight,
    handleReplaceClick,
    startTime,
    endTime,
    thumbnails,
}) => {
    const [showCropModal, setShowCropModal] = useState(false)
    const [selectedCroppedAreaPixels, setSelectedCroppedAreaPixels] = useState({})

    const handleCrop = (croppedArea, croppedAreaPixels, zoom) => {
        setSelectedCroppedAreaPixels({ croppedArea, croppedAreaPixels, zoom })
    }

    const cropImage = () => {
        onCrop(selectedCroppedAreaPixels)
        setShowCropModal(false)
    }

    return (
        <>
            <Col>
                <Card className="tw:!w-fit" style={{ borderRadius: '2px', backgroundColor: '#17273C', border: 0 }}>
                    <Card.Body style={{ padding: '8px 12px' }} className="tw:!w-fit">
                        <Card.Title style={{ fontSize: 14, fontWeight: 600 }}>{title}</Card.Title>
                        <Form.Check
                            type="radio"
                            name={aspect}
                            id={`${aspect}-original`}
                            label="Original"
                            checked={selectedOption === 'original'}
                            onChange={() => onOptionChange('original')}
                        />
                        <Form.Check
                            type="radio"
                            name={aspect}
                            id={`${aspect}-cropped`}
                            label={ratio}
                            checked={selectedOption === 'cropped'}
                            onChange={() => onOptionChange('cropped')}
                        />
                        <div style={imageWrapperStyles(ratio)} className="my-3 tw:relative">
                            <Media
                                type={type}
                                url={originalUrl}
                                aspect={aspectRatio}
                                canvasWidth={canvasWidth}
                                canvasHeight={canvasHeight}
                                cropData={selectedOption === 'cropped' ? croppedAreaPixels : null}
                                startTime={startTime}
                                endTime={endTime}
                                thumbnails={thumbnails}
                            />
                        </div>
                        <div className="d-flex justify-content-between" style={{ gap: 12 }}>
                            <Button
                                variant="btn btn-outline-light media-buying-button-action d-flex align-items-center justify-content-center"
                                style={{ fontSize: 13, marginLeft: 0, flex: 1, gap: 4 }}
                                onClick={() => setShowCropModal(true)}
                            >
                                <Crop size={16} />
                                Crop
                            </Button>
                            <Button
                                onClick={handleReplaceClick}
                                style={{ fontSize: 13, marginLeft: 0, flex: 1, gap: 4 }}
                                variant="btn btn-outline-light media-buying-button-action d-flex align-items-center justify-content-center"
                            >
                                <ArrowRightLeft size={16} />
                                Replace
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <AppModal
                title={`Crop ${_.capitalize(type)}`}
                confirmText="Crop"
                show={showCropModal}
                onConfirm={cropImage}
                onCancel={() => setShowCropModal(false)}
            >
                <ImageCropper
                    type={type}
                    endTime={endTime}
                    url={originalUrl}
                    startTime={startTime}
                    onComplete={handleCrop}
                    aspectRatio={aspectRatio}
                    croppedArea={croppedArea}
                    videoDuration={videoDuration}
                    croppedAreaPixels={croppedAreaPixels}
                />
            </AppModal>
        </>
    )
}

const imageWrapperStyles = (ratio) => ({
    aspectRatio: ratio.replace(':', ' / '),
    overflow: 'hidden',
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#3B5168',
})

export default MediaFormat
